import { CartItem } from './cart-item';

export class Transaction {
    id = 0;
    email = '';
    status = 0;
    subtotal = 0;
    additional: any = 0;
    discount: any = 0;
    discount_payment = 0;
    delivery = 0;
    total: any = 0;
    fingerprint = '';
    created_at = '';
    data_payment: any = {};
    payment_type = 0;
    installment: any = {};
    coupon_code?: string;
    coupon_amount?: number;

    items = new Array<CartItem>();
}
